// This file was automatically generated from print.html.
// Please don't edit this file by hand.

goog.provide('el8.template.print');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.data.practices');
goog.require('el8.template.ptdata.patients');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.currentAsOf = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<p class="italic mt25 fr">As of ', (soy.$$escapeHtml(opt_data.now)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.now)) : ''), ', in <img src="', (opt_data.localFsPath) ? 'file://' + soy.$$escapeHtml(opt_data.localFsPath) + '/..' : '', '/static/images/logo_fax_300dpi.jpg', (! opt_data.localFsPath) ? '?v=20160729' : '', '" height="12" width="80"></p>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.signature = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.signDate) {
    output.append('<div class="eSignatureWrapper">', (opt_data.esignatureUrl) ? '<p class="eSignatureImage"><img alt="Signature" style="max-height: 50px" src="' + soy.$$escapeHtml(opt_data.esignatureUrl) + '"/></p>' : (opt_data.isOrder) ? '<p class="signatureLine">Physician Signature: ________________________________________________</p><br/>' : '', '<div class="signatureContainer">', (opt_data.receiveDate) ? '<p class="signerText">Added on ' + (soy.$$escapeHtml(opt_data.receiveDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.receiveDate)) : '') + '</p>' : '', (opt_data.signPhysicianName || opt_data.signPhysician) ? '<p class="signerText">Signed electronically by ' + ((opt_data.signPhysicianName) ? soy.$$escapeHtml(opt_data.signPhysicianName) : soy.$$escapeHtml(opt_data.signPhysician.fullName)) + ' on ' + (soy.$$escapeHtml(opt_data.signDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.signDate)) : '') + ' in <img src="' + ((opt_data.localFsPath) ? 'file://' + soy.$$escapeHtml(opt_data.localFsPath) + '/..' : '') + '/static/images/logo_fax_300dpi.jpg' + ((! opt_data.localFsPath) ? '?v=20160729' : '') + '" height="12" width="80"></p>' : '');
    if (opt_data.signPhysicianIdentifiers) {
      output.append('<div class="signatureCreds">');
      el8.template.print._physicianIdentifiers({identifiersList: opt_data.signPhysicianIdentifiers}, output);
      output.append('</div>');
    }
    output.append('</div><div class="signatureContainer">');
    el8.template.print._supervisingPhysician(opt_data, output);
    output.append('</div></div>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.signatureNew = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.signDate) ? '<div class="signature-box">' + ((opt_data.esignatureUrl) ? '<img alt="Signature" style="max-height: 50px" src="' + soy.$$escapeHtml(opt_data.esignatureUrl) + '"/>' : '') + '</div><div class="signature-label">' + ((opt_data.signPhysicianName) ? soy.$$escapeHtml(opt_data.signPhysicianName) : soy.$$escapeHtml(opt_data.signPhysician.fullName)) + '&nbsp;<span class="font-light">' + (soy.$$escapeHtml(opt_data.signDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.signDate)) : '') + '</span></div>' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.signatureMulti = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.signDate) {
    output.append('<div class="eSignatureWrapperMulti">');
    if (opt_data.signPhysicianIdentifiers) {
      output.append('<div class="signatureCredsMulti"><p class="signerTextMulti">', (opt_data.signPhysicianName) ? soy.$$escapeHtml(opt_data.signPhysicianName) : soy.$$escapeHtml(opt_data.signPhysician.fullName), '</p>');
      el8.template.print._physicianIdentifiers({identifiersList: opt_data.signPhysicianIdentifiers}, output);
      output.append('</div>');
    }
    output.append((opt_data.esignatureUrl) ? '<p class="signatureLineMulti"><img alt="e-signature" style="max-height: 50px" src="' + soy.$$escapeHtml(opt_data.esignatureUrl) + '"/></p>' : '<p class="signatureLineMulti"></p>', '<div class="signatureLabelMulti">', (opt_data.esignatureUrl) ? '<p>Electronically signed by ' + ((opt_data.signPhysicianName) ? soy.$$escapeHtml(opt_data.signPhysicianName) : soy.$$escapeHtml(opt_data.signPhysician.fullName)) + ' on ' + (soy.$$escapeHtml(opt_data.signDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.signDate)) : '') + ' in <img alt="e-signature" src="' + ((opt_data.localFsPath) ? 'file://' + soy.$$escapeHtml(opt_data.localFsPath) + '/..' : '') + '/static/images/logo_fax_300dpi.jpg' + ((! opt_data.localFsPath) ? '?v=20160729' : '') + '" height="12" width="80"> .</p>' : '<p>Signature of Prescriber</p>', '</div><div class="supervisorCredsMulti">');
    el8.template.print._supervisingPhysician(opt_data, output);
    output.append('</div></div>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.signatureOH = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.signDate) {
    output.append('<div class="eSignatureWrapperOH"><p class="signatureLineDefault"></p><div class="signatureLabelDefault"><p>Signature of Prescriber</p></div>');
    if (opt_data.signPhysicianIdentifiers) {
      output.append('<div class="signatureCredsOH"><p class="signerTextDefault">', (opt_data.signPhysicianName) ? soy.$$escapeHtml(opt_data.signPhysicianName) : soy.$$escapeHtml(opt_data.signPhysician.fullName), '</p>');
      el8.template.print._physicianIdentifiers({identifiersList: opt_data.signPhysicianIdentifiers}, output);
      output.append('</div>');
    }
    output.append('<div class="supervisorCredsOH">');
    el8.template.print._supervisingPhysician(opt_data, output);
    output.append('</div></div>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.signatureNY = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.signDate) ? '<div class="eSignatureWrapperNY">' + ((opt_data.esignatureUrl) ? '<p class="signatureLineNY"><img alt="Signature" style="max-height: 50px" src="' + soy.$$escapeHtml(opt_data.esignatureUrl) + '"/></p>' : '<p class="signatureLineNY"></p>') + '<div class="signatureLabelNY">' + ((opt_data.esignatureUrl) ? '<p>Electronically signed by ' + ((opt_data.signPhysicianName) ? soy.$$escapeHtml(opt_data.signPhysicianName) : soy.$$escapeHtml(opt_data.signPhysician.fullName)) + ' on ' + (soy.$$escapeHtml(opt_data.signDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.signDate)) : '') + ' in <img src="' + ((opt_data.localFsPath) ? 'file://' + soy.$$escapeHtml(opt_data.localFsPath) + '/..' : '') + '/static/images/logo_fax_300dpi.jpg' + ((! opt_data.localFsPath) ? '?v=20160729' : '') + '" height="12" width="80"> .</p>' : '<p>Signature of Prescriber</p>') + '</div></div>' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.signerNY = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.signDate) {
    output.append('<div class="signerWrapperNY">');
    if (opt_data.signPhysicianIdentifiers) {
      output.append('<div class="signerCredsNY"><p class="signerTextNY">', (opt_data.signPhysicianName) ? soy.$$escapeHtml(opt_data.signPhysicianName) : soy.$$escapeHtml(opt_data.signPhysician.fullName), '</p>');
      el8.template.print._physicianIdentifiers({identifiersList: opt_data.signPhysicianIdentifiers}, output);
      output.append('</div>');
    }
    output.append('<div class="supervisorCredsNY">');
    el8.template.print._supervisingPhysician(opt_data, output);
    output.append('</div></div>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.rxCredsSC = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.signDate) {
    output.append('<div class="signatureCreds">');
    if (opt_data.esignatureUrl) {
      output.append('<p>Electronically signed by ', (opt_data.signPhysicianName) ? soy.$$escapeHtml(opt_data.signPhysicianName) : soy.$$escapeHtml(opt_data.signPhysician.fullName), ' on ', (soy.$$escapeHtml(opt_data.signDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.signDate)) : ''), ' in <img src="', (opt_data.localFsPath) ? 'file://' + soy.$$escapeHtml(opt_data.localFsPath) + '/..' : '', '/static/images/logo_fax_300dpi.jpg', (! opt_data.localFsPath) ? '?v=20160729' : '', '" height="12" width="80"> .</p>');
    } else {
      output.append('<p class="signerText">', (opt_data.signPhysicianName) ? soy.$$escapeHtml(opt_data.signPhysicianName) : soy.$$escapeHtml(opt_data.signPhysician.fullName), '</p>');
      el8.template.print._physicianIdentifiers({identifiersList: opt_data.signPhysicianIdentifiers}, output);
    }
    output.append('</div><div class="signatureCreds">');
    el8.template.print._supervisingPhysician(opt_data, output);
    output.append('</div>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.rxCredsWA = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.signDate) {
    output.append('<div class="signatureCreds">');
    if (opt_data.esignatureUrl) {
      output.append('<p class="signerText">Electronically signed by ', (opt_data.signPhysicianName) ? soy.$$escapeHtml(opt_data.signPhysicianName) : soy.$$escapeHtml(opt_data.signPhysician.fullName), ' on ', (soy.$$escapeHtml(opt_data.signDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.signDate)) : ''), ' in <img src="', (opt_data.localFsPath) ? 'file://' + soy.$$escapeHtml(opt_data.localFsPath) + '/..' : '', '/static/images/logo_fax_300dpi.jpg', (! opt_data.localFsPath) ? '?v=20160729' : '', '" height="12" width="80"> .</p>');
      el8.template.print._physicianIdentifiers({identifiersList: opt_data.signPhysicianIdentifiers}, output);
    } else {
      output.append('<p class="signerText">', (opt_data.signPhysicianName) ? soy.$$escapeHtml(opt_data.signPhysicianName) : soy.$$escapeHtml(opt_data.signPhysician.fullName), '</p>');
      el8.template.print._physicianIdentifiers({identifiersList: opt_data.signPhysicianIdentifiers}, output);
    }
    output.append('<div class="supervisorCreds">');
    el8.template.print._supervisingPhysician(opt_data, output);
    output.append('</div></div>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.signatureAL = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.signDate) {
    output.append('<div class="eSignatureWrapperAL">  <!-- Need two signature lines side-by-side --><div style="display: inline-block; vertical-align: top; padding-right: 6px;"><p class="signatureLineDefault"></p><div class="signatureLabelDefault"><p>Signature of Prescriber</p><p>Dispense as written.</p></div></div><div style="display: inline-block; vertical-align: top;"><p class="signatureLineDefault"></p><div class="signatureLabelDefault"><p>Signature of Prescriber</p><p>Substitutions permissible.</p></div></div><div class="supervisorCredsOH">');
    if (opt_data.signPhysicianIdentifiers) {
      output.append('<div class="signatureCredsOH"><p class="signerTextDefault">', (opt_data.signPhysicianName) ? soy.$$escapeHtml(opt_data.signPhysicianName) : soy.$$escapeHtml(opt_data.signPhysician.fullName), '</p>');
      el8.template.print._physicianIdentifiers({identifiersList: opt_data.signPhysicianIdentifiers}, output);
      output.append('</div>');
    }
    el8.template.print._supervisingPhysician(opt_data, output);
    output.append('</div></div>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print._physicianIdentifiers = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  var identifierList13008 = opt_data.identifiersList;
  var identifierListLen13008 = identifierList13008.length;
  for (var identifierIndex13008 = 0; identifierIndex13008 < identifierListLen13008; identifierIndex13008++) {
    var identifierData13008 = identifierList13008[identifierIndex13008];
    output.append((identifierData13008.value) ? soy.$$escapeHtml(identifierData13008.name) + ': ' + soy.$$escapeHtml(identifierData13008.value) + ((! (identifierIndex13008 == identifierListLen13008 - 1)) ? ' &middot; ' : '') : '');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.physicianIdentifiers = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  var identifierList13019 = opt_data.identifiersList;
  var identifierListLen13019 = identifierList13019.length;
  for (var identifierIndex13019 = 0; identifierIndex13019 < identifierListLen13019; identifierIndex13019++) {
    var identifierData13019 = identifierList13019[identifierIndex13019];
    output.append((identifierData13019.value) ? soy.$$escapeHtml(identifierData13019.name) + ': ' + soy.$$escapeHtml(identifierData13019.value) + ((! (identifierIndex13019 == identifierListLen13019 - 1)) ? '<span class="big-bullet"></span>' : '') : '');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print._supervisingPhysician = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.supervisingPhysician) {
    output.append('<p>Supervisor: ', soy.$$escapeHtml(opt_data.supervisingPhysician.fullName), '</p>');
    el8.template.print._physicianIdentifiers({identifiersList: opt_data.supervisingPhysicianIdentifiers}, output);
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.patientInfoFooter = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="fl">Patient: ');
  el8.template.ptdata.patients.displayName(opt_data.patient, output);
  output.append(', D.O.B.: ', soy.$$escapeHtml(opt_data.patient.dob), '</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.patientInfo = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  el8.template.print.patientDemog(soy.$$augmentData(opt_data, {phrase: 'Cared for', physicianName: opt_data.patient.primaryPhysicianName}), output);
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.patientDemog = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="patientInfo"><p class="patientName">Patient Name: ');
  el8.template.ptdata.patients.displayName(opt_data.patient, output);
  output.append('</p><p>D.O.B.: ', soy.$$escapeHtml(opt_data.patient.dob), '; ', soy.$$escapeHtml(opt_data.patient.displayAge), ' at the time of printing this document</p><p>Gender: ', (opt_data.patient.sex == 'M') ? 'Male' : (opt_data.patient.sex == 'F') ? 'Female' : 'Unknown', '</p><p>Patient ID: ', soy.$$escapeHtml(opt_data.patient.id), '</p>', (opt_data.phrase && opt_data.physicianName) ? '<p>' + soy.$$escapeHtml(opt_data.phrase) + ' by ' + soy.$$escapeHtml(opt_data.physicianName) + '</p>' : '', '</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.patientInfoNotes = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="patientInfo"><p class="patientName">Patient Name: ');
  el8.template.ptdata.patients.displayName(opt_data.patient, output);
  output.append('</p><p>D.O.B.: ', soy.$$escapeHtml(opt_data.patient.dob), '; ', soy.$$escapeHtml(opt_data.displayPatientAge), ' at the time of ', soy.$$escapeHtml(opt_data.timeOfPhrase), '</p>', (opt_data.physicianName) ? '<p>Seen by ' + soy.$$escapeHtml(opt_data.physicianName) + '</p>' : '', '</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.header = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  el8.template.data.practices.header(opt_data.practice, output);
  output.append((opt_data.practice.isPatient) ? '<div class="pageHeaderContainer"><h4>*** Printed By Patient ***</h4></div>' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.documentedBy = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="signatureContainer"><p class="normalText">Documented by ', soy.$$escapeHtml(opt_data.documentingStaffName), ' on ', (soy.$$escapeHtml(opt_data.signDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.signDate)) : ''), '.</p></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.sentBy = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.signDate) ? '<div class="eSignatureWrapper">' + ((opt_data.esignatureUrl) ? '<p class="eSignatureImage"><img alt="Signature" style="max-height: 50px" src="' + soy.$$escapeHtml(opt_data.esignatureUrl) + '"/></p>' : '') + '<div class="signatureContainer">' + ((opt_data.signUserBehalfName) ? '<p class="normalText">Electronically signed off and sent by ' + soy.$$escapeHtml(opt_data.signUserBehalfName) + ' for ' + soy.$$escapeHtml(opt_data.signUserName) + ' in <img src="' + ((opt_data.localFsPath) ? 'file://' + soy.$$escapeHtml(opt_data.localFsPath) + '/..' : '') + '/static/images/logo_fax_300dpi.jpg' + ((! opt_data.localFsPath) ? '?v=20160729' : '') + '" height="12" width="80"> .</p>' : '<p class="normalText">Sent by ' + soy.$$escapeHtml(opt_data.signUserName) + ' on ' + (soy.$$escapeHtml(opt_data.signDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.signDate)) : '') + ' in <img src="' + ((opt_data.localFsPath) ? 'file://' + soy.$$escapeHtml(opt_data.localFsPath) + '/..' : '') + '/static/images/logo_fax_300dpi.jpg' + ((! opt_data.localFsPath) ? '?v=20160729' : '') + '" height="12" width="80"> .</p>') + '</div></div>' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.headerInfoOrders = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.title) ? '<h1 class="documentTitle">' + soy.$$escapeHtml(opt_data.title) + '</h1>' : (opt_data.order && opt_data.order.orderType) ? '<h1 class="documentTitle">' + ((opt_data.order.testCenterCompanyName) ? '<span class="fr h2 el8Bold mt5">' + soy.$$escapeHtml(opt_data.order.testCenterCompanyName) + '</span>' : '') + '<!-- Sleep to Generic order UI reskin -->' + ((el8Globals.FEATURES.GenericOrder && opt_data.order.orderType == 'sleep') ? 'Order' : (soy.$$escapeHtml(opt_data.order.orderType)? soy.$$escapeHtml(opt_data.order.orderType).capitalize() : '') + ' Order') + '</h1>' : '', '<div class="w100"><div class="ptDemogsSection">', (opt_data.patient.middleName) ? '<div class="extraSmallText italic ptDOBContainer">First - Middle - Last</div>' : '<div class="extraSmallText italic ptDOBContainer">First - Last</div>', '<p class="fl emphasis">For:</h2><p class="ptDOBContainer emphasis">', soy.$$escapeHtml(opt_data.patient.firstName), ' ', (opt_data.patient.middleName) ? soy.$$escapeHtml(opt_data.patient.middleName) + ' ' : '', soy.$$escapeHtml(opt_data.patient.lastName), '</p><p class="fl extraSmallText">D.O.B.:</p><p class="ptDOBContainer">', soy.$$escapeHtml(opt_data.patient.dob), (opt_data.patient.sex == 'M') ? ' (Male)' : (opt_data.patient.sex == 'F') ? ' (Female)' : '', '</p>', (opt_data.patient.addressLine) ? '<p class="fl extraSmallText">Addr.:</p><p class="ptDOBContainer">' + soy.$$escapeHtml(opt_data.patient.addressLine) + ((opt_data.patient.cityStateZip) ? ', ' + soy.$$escapeHtml(opt_data.patient.cityStateZip) : '') + '</p>' : '', (opt_data.patient.phone1) ? '<p class="fl extraSmallText">Phone:</p><p class="ptDOBContainer">' + soy.$$escapeHtml(opt_data.patient.phone1) + '</p>' : '');
  if (! opt_data.noInsurance) {
    if (opt_data.patient.primaryInsurance && opt_data.patient.primaryInsurance.isNonEmpty) {
      output.append('<p class="fl extraSmallText">Ins:<p><p class="ptDOBContainer">');
      el8.template.ptdata.patients.insuranceSummary(opt_data.patient.primaryInsurance, output);
      output.append('</p>');
    }
    if (opt_data.patient.secondaryInsurance && opt_data.patient.secondaryInsurance.isNonEmpty) {
      output.append('<p class="fl extraSmallText">2nd Ins:<p><p class="ptDOBContainer">');
      el8.template.ptdata.patients.insuranceSummary(opt_data.patient.secondaryInsurance, output);
      output.append('</p>');
    }
  }
  output.append('</div></div><div class="DemogsBreak"></div>', (opt_data.order && (opt_data.order.testCenterName || opt_data.order.dateForTest || opt_data.order.displayStatMethod)) ? '<div class="topDetailsContainer">' + ((opt_data.order && opt_data.order.testCenterName) ? '<p class="normalText mt10"><span class="el8Bold"><!-- Sleep to Generic order UI reskin -->' + ((el8Globals.FEATURES.GenericOrder && opt_data.order.orderType == 'sleep') ? 'Test Center:' : (soy.$$escapeHtml(opt_data.order.orderType)? soy.$$escapeHtml(opt_data.order.orderType).capitalize() : '') + ' Test Center:') + '</span><br>' + soy.$$escapeHtml(opt_data.order.testCenterName) + '</p>' + ((opt_data.order.testCenterAddressLine || opt_data.order.testCenterCityStateZip) ? ((opt_data.order.testCenterAddressLine) ? '<p class="normalText">' + soy.$$escapeHtml(opt_data.order.testCenterAddressLine) + '</p>' : '') + ((opt_data.order.testCenterCityStateZip) ? '<p class="normalText">' + soy.$$escapeHtml(opt_data.order.testCenterCityStateZip) + '</p>' : '') : '') + ((opt_data.order.testCenterPhone) ? '<p class="normalText">Phone: ' + soy.$$escapeHtml(opt_data.order.testCenterPhone) + '</p>' : '') + ((opt_data.order.testCenterFax) ? '<p class="normalText">Fax: ' + soy.$$escapeHtml(opt_data.order.testCenterFax) + '</p>' : '') : '') + ((opt_data.order && (opt_data.order.dateForTest || opt_data.order.displayStatMethod)) ? ((opt_data.order.dateForTest) ? '<p class="normalText mt10"><span class="el8Bold">Dr. Wants Test Done Around:</span><br>' + (soy.$$escapeHtml(opt_data.order.dateForTest)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.order.dateForTest)) : '') + '</p>' : '') + ((opt_data.order.displayStatMethod) ? '<p class="normalText mt10">**' + soy.$$escapeHtml(opt_data.order.displayStatMethod) + '**</p>' : '') : '') + '</div>' : '');
  if (!opt_sb) return output.toString();
};
